<template>
  <section class="service-wrapper">
    <div
      class="service-container"
      :style="{
        backgroundImage: `url(${configDataForm.backGroundImageFullUrl || noUpload})`,
        'background-repeat': 'no-repeat',
        'background-size': 'cover',
        'background-position': 'center',
      }"
      @mouseenter="handleShowOperationBtn(props.showEditContentButton)"
      @mouseleave="handleShowOperationBtn(false)"
    >
      <header class="title">
        <figure class="title-icon">
          <img
            :src="iconFileFullUrl || noUpload"
            alt="标题图标"
            loading="lazy"
          />
        </figure>
        <h2
          class="title-text"
          :style="{
            color: configDataForm.fontColor,
          }"
        >
          {{ configDataForm.title }}
        </h2>
      </header>
      <div class="content">
        <article
          v-for="(item, index) in configDataForm.items"
          :key="index"
          class="service-item"
          role="article"
          :aria-label="item.title"
        >
          <a target="_blank" :href="item.linkUrl">
            <figure
              class="service-item-icon"
              :style="{
                background: item.backGroundColor,
              }"
            >
              <img
                :src="item.itemFileFullUrl || noUpload"
                :alt="item.title"
                loading="lazy"
              />
            </figure>
            <h3
              class="service-item-title"
              :style="{
                color: item.fontColor,
              }"
            >
              {{ item.title }}
            </h3>
          </a>
        </article>
      </div>
      <operation-container
        v-if="showOperationBtn && !showEditForm"
        :component-data="props.componentData"
        :show-edit-content-button="props.showEditContentButton"
        :show-edit-components-button="props.showEditComponentsButton"
        :show-delete-components-button="props.showDeleteComponentsButton"
        :show-insert-components-button="props.showInsertComponentsButton"
        :show-sort-components-button="props.showSortComponentsButton"
        @handle-show-edit-form="handleShowEditForm"
        @handle-change-components="handleChangeComponents"
        @handle-delete-components="handleDeleteComponents"
        @handle-insert-components="handleInsertComponents"
        @handle-sort-components="handleSortComponents"
      ></operation-container>
    </div>
    <el-drawer
      v-if="showEditForm"
      v-model="showEditForm"
      size="60%"
      :title="props.componentData.componentName"
    >
      <image-text-edit-form
        v-if="showEditForm"
        v-model="configDataForm"
        :component-data="props.componentData"
        @handle-show-edit-form="handleShowEditForm"
        @handle-edit-components-content="handleEditComponentsContent"
      ></image-text-edit-form>
    </el-drawer>
  </section>
</template>
<script setup>
// #region 引用
import OperationContainer from '../common/OperationContainer.vue';
import ImageTextEditForm from './ImageTextEditFormSixteen.vue';
// #endregion

// #region props/emit
/**
 * 属性
 */
const props = defineProps({
  showEditContentButton: {
    type: Boolean,
    default: true,
  },
  showEditComponentsButton: {
    type: Boolean,
    default: false,
  },
  showDeleteComponentsButton: {
    type: Boolean,
    default: false,
  },
  showInsertComponentsButton: {
    type: Boolean,
    default: false,
  },
  showSortComponentsButton: {
    type: Boolean,
    default: false,
  },
  componentData: {
    type: Object,
    default() {},
  },
});

// console.log('props-configDataForm:',props);

/**
 * 方法
 */
const emits = defineEmits([
  'handle-show-edit-form',
  'handle-change-components',
  'handle-delete-components',
  'handle-insert-components',
  'handle-sort-components',
  'handle-edit-components-content',
  'update:modelValue',
]);

// #endregion

// #region 变量/常量

// 处理图片未上传的情况
// 预加载所有图片（构建时生成映射）
const images = import.meta.glob('@/assets/images/web/common/other/*.png', {
  eager: true,
  query: '?url',
});
// 直接获取目标图片 URL
const noUpload =
  images['/src/assets/images/web/common/other/no-upload.png']?.default;

// 表单绑定对象
const configDataForm = ref({
  contentImageObj: null,
  imageName: '',
  imageFileKey: 'contentImage',
  backGroundImageObj: null,
  backgroundImageName: '',
  backgroundImageFileKey: 'backgroundImage',
  title: '示例标题',
  content: '示例内容',
  textColor: '#ffffff',
  backgroundColor: '#008bd5',
});

if (props.componentData.configData) {
  // 服务器渲染的直接调用
  configDataForm.value = JSON.parse(props.componentData.configData);
  configDataForm.value.items.sort((a, b) => {
    return a.sortNum - b.sortNum;
  });
}

// 图标
const iconFileFullUrl = computed(() => {
  return configDataForm.value ? configDataForm.value.iconFullUrl : '';
});

// 操作显示按钮控制
const showOperationBtn = ref(false);
// 显示编辑表单
const showEditForm = ref(false);

// #endregion

// #region 生命周期

// #endregion

// #region 业务方法
/**
 * 显示
 */
const handleShowOperationBtn = (flag) => {
  showOperationBtn.value = flag;
};
/**
 * 显示编辑表单
 */
const handleShowEditForm = (flag) => {
  showEditForm.value = flag;
};
/**
 * 处理编辑表单内容
 */
const handleEditComponentsContent = (flag) => {
  // console.log('configDataForm--1:', configDataForm);
  // 待数据更新完成后才执行
  nextTick(() => {
    emits('update:modelValue', configDataForm.value);
    emits('handle-edit-components-content', true);
  });

  handleShowEditForm(flag);
};

/**
 * 改变组件
 */
const handleChangeComponents = () => {
  emits('handle-change-components', true);
};

/**
 * 删除组件
 */
const handleDeleteComponents = () => {
  emits('handle-delete-components', true);
};

/**
 * 插入组件
 */
const handleInsertComponents = () => {
  emits('handle-insert-components');
};
/**
 * 组件排序
 */
const handleSortComponents = (moveObj) => {
  emits('handle-sort-components', moveObj);
};

// #endregion
</script>
<style scoped lang="scss">
// ========================================
// 🎨 现代化升级 v2.0 - 2026-03-08
// 优化内容：
// 1. 标题渐变下划线
// 2. 卡片化设计（圆角+背景）
// 3. hover 才旋转动画（性能优化）
// 4. CSS Grid 响应式布局
// 如需回滚，删除标记区域代码
// ========================================

// [PC端优化-2026-03-10] 统一设计变量
$radius-md: 8px;
$radius-lg: 12px;
$shadow-sm: 0 2px 8px rgb(0 0 0 / 6%);
$shadow-md: 0 4px 12px rgb(0 0 0 / 8%);
$shadow-lg: 0 8px 24px rgb(0 0 0 / 12%);
$shadow-hover: 0 12px 32px rgb(0 0 0 / 16%);
$transition-normal: 0.35s cubic-bezier(0.4, 0, 0.2, 1);
$gradient-primary: linear-gradient(90deg, #1a5fb4 0%, #00b4d8 100%);

@media screen and (width >= 1181px) {
  .service-wrapper {
    width: 100%;
  }

  .service-container {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: self-start;
    justify-content: center;
    width: 100%;
    padding: 40px 100px;

    .title {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      justify-content: flex-start;
      width: 100%;
      height: 60px;
      padding-bottom: 20px;
      // [恢复] 原始灰色边框
      border-bottom: 1px solid #cfd0c5;

      .title-icon {
        width: 40px;
        height: 40px;
        margin-right: 20px;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .title-text {
        flex-grow: 1;
        height: 40px;
        margin-bottom: 20px;
        font-size: 36px;
        font-weight: 600;
        line-height: 40px;
      }
    }

    // [优化4-开始] CSS Grid 响应式布局
    // 原代码: display: flex; flex-wrap: wrap; gap: 40px;
    .content {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
      // [间距调整-2026-03-08] 40px → 30px
      gap: 30px;
      width: 100%;
      max-width: 1600px;
      padding: 20px 0 0;
      margin: 0 auto;
      // [优化4-结束]

      .service-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        // [优化2-开始] 卡片化设计
        // 原代码: justify-content: space-around; width: 220px; height: 280px;
        padding: 24px 16px;
        // background: #fff;
        border-radius: $radius-lg;
        box-shadow: $shadow-sm;
        transition: all $transition-normal;

        &:hover {
          box-shadow: $shadow-md;
          transform: translateY(-4px);
        }
        // [优化2-结束]

        a {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-around;
          width: 100%;
          min-height: 240px;
        }

        .service-item-icon {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 160px;
          height: 160px;
          cursor: pointer;
          border-radius: 50%;
          box-shadow:
            $shadow-md,
            0 0 0 1px rgb(26 95 180 / 10%);
          transition: all $transition-normal;

          img {
            width: 66px;
            height: 66px;
            object-fit: cover;
            transition: transform $transition-normal;
          }

          &:hover {
            box-shadow:
              $shadow-hover,
              0 0 0 2px rgb(0 180 216 / 30%),
              0 0 30px rgb(0 180 216 / 20%);
            transform: translateY(-8px) scale(1.05);

            img {
              transform: scale(1.1);
            }

            // [优化3-开始] hover 才旋转
            // 原代码: animation 在 ::before 上一直执行
            &::before {
              animation: rotate 20s linear infinite;
            }
            // [优化3-结束]
          }
        }

        // [优化3-开始] 默认不旋转
        // 原代码: animation: rotate 20s linear infinite;
        .service-item-icon::before {
          position: absolute;
          inset: -20px;
          content: '';
          background: conic-gradient(
            from 0deg,
            #1a5fb4 0%,
            #00b4d8 50%,
            #1a5fb4 100%
          );
          border: 8px dashed;
          border-color: #0d47a1;
          border-radius: 50%;
          mask: radial-gradient(transparent 50%, black 51%);
          animation: none; // 默认不旋转
        }
        // [优化3-结束]

        .service-item-icon::after {
          position: absolute;
          inset: 5px;
          content: '';
          border-radius: 50%;
        }

        .service-item-title {
          margin-top: 10px;
          // [字号调整-2026-03-08] 18px → 20px
          font-size: 20px;
          font-weight: 700;
          text-align: center;
          transition: all $transition-normal;
        }

        &:hover .service-item-title {
          // [优化1-关联] 标题 hover 变色
          color: #00b4d8;
          transform: translateY(-4px);
        }
      }
    }
  }
}
</style>

<style scoped lang="scss">
/* [移动端优化-2026-03-10] 基于设计四大原则 */
$transition-normal: 0.35s cubic-bezier(0.4, 0, 0.2, 1);

@media screen and (width <= 1180px) {
  .service-wrapper {
    width: 100%;
  }

  .service-container {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: auto;
    padding: 4vw;

    .title {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      justify-content: center;
      width: 100%;
      height: auto;
      padding-bottom: 4vw;

      .title-icon {
        display: flex;
        align-content: center;
        align-items: center;
        font-size: 7.5vw;

        img {
          width: 7.5vw;
          height: 7.5vw;
          margin-right: 2vw;
          object-fit: contain;
          // [灵动-2026-03-11] 标题图标脉动发光（与ColumnContentSix保持一致）
          animation: iconGlow 2s ease-in-out infinite;
        }
      }

      .title-text {
        flex-grow: 1;
        height: auto;
        font-size: 5vw;
        font-weight: 600;
        line-height: 1.4;
      }
    }

    // 恢复原来的flex布局
    .content {
      display: flex;
      flex-grow: 1;
      flex-wrap: wrap;
      align-items: flex-start;
      width: 92vw;

      .service-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
        width: 22vw;
        height: 30vw;
        margin-right: 1vw;

        a {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-around;
          height: 28vw;
        }

        .service-item-icon {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 13vw;
          height: 13vw;
          cursor: pointer;
          border-radius: 50%;
          transition:
            transform 250ms ease,
            box-shadow 250ms ease;

          img {
            width: 7.5vw;
            height: 7.5vw;
            object-fit: cover;
            transition: transform 250ms ease;
          }

          &:active {
            transform: scale(0.95);

            img {
              transform: scale(1.1);
            }

            // [优化3-移动端] active 时旋转
            &::before {
              animation: rotate 20s linear infinite;
            }
          }
        }

        // [优化3-移动端] 默认不旋转
        .service-item-icon::before {
          position: absolute;
          inset: -4vw;
          content: '';
          background: conic-gradient(
            from 0deg,
            #1a5fb4 0%,
            #00b4d8 50%,
            #1a5fb4 100%
          );
          border: 1vw dashed;
          border-color: #0d47a1;
          border-radius: 50%;
          mask: radial-gradient(transparent 50%, black 51%);
          animation: none;
        }

        .service-item-icon::after {
          position: absolute;
          inset: 1vw;
          content: '';
          border-radius: 50%;
        }

        .service-item-title {
          margin-top: 2vw;
          // [字号调整-2026-03-08] 3.75vw → 4vw
          font-size: 4vw;
          font-weight: 700;
          text-align: center;
          transition: transform 250ms ease;
        }

        &:active .service-item-title {
          transform: scale(0.98);
        }
      }
    }
  }
}
</style>
